'use client';

import type { DownloadButtonProps } from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';
import { AnonymousAlertSnapshotIcon } from './AnonymousAlertSnapshotIcon';
import { AnonymousUserSnapshotIcon } from './AnonymousUserSnapshotIcon';
import { useSnapshotAuth } from './useSnapshotAuth';
import { useSnapshotSubscription } from './useSnapshotSubscription';

interface AccountSnapshotIconsProps {
    appdownloadItem?: DownloadButtonProps[];
    /** Called when either snapshot popover opens, so the host can close its own overlays. */
    onOpen?: () => void;
}

export function AccountSnapshotIcons({ appdownloadItem, onOpen }: AccountSnapshotIconsProps): React.JSX.Element {
    const {
        authState,
        isRestoringAuth,
        authenticatedUser,
        teslaManageSelection,
        handleAuthenticated,
        handleSignOut,
    } = useSnapshotAuth();
    const subscriptionState = useSnapshotSubscription(
        authState,
        authenticatedUser?.accountNumber ?? null,
        authenticatedUser?.accountDetailsResponse,
    );

    return (
        <>
            <AnonymousAlertSnapshotIcon
                authState={authState}
                firstName={authenticatedUser?.firstName ?? null}
                isRestoringAuth={isRestoringAuth}
                onOpen={onOpen}
            />
            <AnonymousUserSnapshotIcon
                appdownloadItem={appdownloadItem}
                authenticatedUser={authenticatedUser}
                isRestoringAuth={isRestoringAuth}
                onOpen={onOpen}
                onAuthenticated={handleAuthenticated}
                onSignOut={handleSignOut}
                subscriptionState={subscriptionState}
                teslaManageSelection={teslaManageSelection}
            />
        </>
    );
}
